export async function retryAsync<T>(
  func: Promise<T>,
  retries = 3,
  delay = 500,
): Promise<T | null> {
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      return await func
    } catch (error) {
      if (attempt < retries) {
        await new Promise((res) => setTimeout(res, delay))
      } else {
        throw error
      }
    }
  }

  return null
}
